import TableBlock from './TableBlock';

export default TableBlock;
